module.exports = __webpack_public_path__ + "img/sieckFinesseSwing3.6fdb65e6.png";